/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CaseCloserPaymentPlans/view.blocks to change it.
import PaymentPlans from './PaymentPlans/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function CaseCloserPaymentPlans({
  children,
  viewPath = "/DesignSystem/CaseCloserPaymentPlans"
  
}) {
  return (<React.Fragment
>
<PaymentPlans
  viewPath={`${viewPath}/PaymentPlans`}
/>
{children}
</React.Fragment>)
}